// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2qrDe","title":"Info_title__3BApY","links":"Info_links__3Z33g","link":"Info_link__1VqRc","logo":"Info_logo__3wNoD"};